import { render, staticRenderFns } from "./ChatInvites.vue?vue&type=template&id=4a142524&"
import script from "./ChatInvites.vue?vue&type=script&lang=js&"
export * from "./ChatInvites.vue?vue&type=script&lang=js&"
import style0 from "./ChatInvites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports